import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-paybyrdLoading',
  templateUrl: './loadingPaybyrd.component.html',
  styleUrls: ['./loadingPaybyrd.component.scss']
})
export class LoadingPaybyrdComponent implements OnInit {
    @Output() emitLoader = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

    onCancelPaybyrd() {
  	// Show a cancel page, or return to cart
  	    this.emitLoader.emit(false);
    }
}
